import React, {useEffect, useState} from "react";
import HttpClient from "./appHttpRequests";
import {Banner, Frame, Loading, Page} from "@shopify/polaris";

export default function SettingsPage(props) {
    // eslint-disable-next-line no-unused-vars
    const [compound_variants_by_sku, setCompound_variants_by_sku] = useState({});
    // eslint-disable-next-line no-unused-vars
    const [variants_by_sku, setVariants_by_sku] = useState({});
    const [isDataLoading, setDataLoading] = useState(true);
    const [loadingError, setLoadingError] = useState('');

    useEffect(() => {
        HttpClient.get(window.SHOPIFY_APP_API_URL + '/settings', )
            .then((response) => {
                if (response.status === 200) {
                    setCompound_variants_by_sku(response.data.compound_variants_by_sku);
                    setVariants_by_sku(response.data.variants_by_sku);
                    setLoadingError('');
                } else {
                    setLoadingError(response.statusText);
                }
                setDataLoading(false);
            })
            .catch((error) => {
                setDataLoading(false);
                setLoadingError(error.response && error.response.data && error.response.data.length < 64
                    ? error.response.data : (error.response && error.response.statusText ? error.response.statusText : 'Unknown error'));
            });
    }, []);

    return (
        <Page title="Settings"
              breadcrumbs={[
                  {
                      content: 'Go back',
                      /* eslint-disable react/prop-types */
                      onAction: props.onClose
                  }
              ]}
        >
            {loadingError ? (
                <Banner
                    title="Error"
                    status="critical"
                >
                    <p>
                        Unable to load settings: {loadingError}
                    </p>
                </Banner>
            ) : (isDataLoading ? (
                <Frame>
                    <Loading/>
                </Frame>
            ) : (
                <b>hello</b>
            ))}
        </Page>
    );
}
